import type { NowCardData } from "@signet/web-kit";
import { RLink } from "./shared.tsx";

/* ──────────────────────────────────────────────────────────────────────────
   Reporting's card on the Now screen: nightly pairs waiting to be taken in.
   It brings its own panel, the frame the core cards use. What the newest
   snapshot added is the Revenue figure now (now.tsx).
   ────────────────────────────────────────────────────────────────────────── */

export function WaitingNowCard({ card }: { card: NowCardData }) {
  const data = card.data as { dates: string[]; count: number };
  return (
    <section className="panel now-card">
      <div className="panel-head">
        <h2>{card.title}</h2>
      </div>
      <div className="panel-body rp-now">
        <p className="rp-small">
          {data.count === 1 ? `The ${data.dates[0]} export pair is stored but not in the workspace yet.` : `${data.count} export pairs are stored but not in the workspace yet, newest ${data.dates[0]}.`}
          {" "}Until then, periods ending on {data.count === 1 ? "that date" : "those dates"} cannot be measured.
        </p>
        <RLink to="/reporting/import" className="secondary-button tiny">{data.count === 1 ? "Take it in" : "Take them in"}</RLink>
      </div>
    </section>
  );
}

/* Infloww accounts the newest import has that no creator claims (server/now.ts). Until one is
   mapped, every card for that creator reads $0. */
export function UnclaimedNowCard({ card }: { card: NowCardData }) {
  const data = card.data as { accounts: string[]; count: number };
  return (
    <section className="panel now-card attention">
      <div className="panel-head">
        <h2>{card.title}</h2>
      </div>
      <div className="panel-body rp-now">
        <p className="rp-small">
          {data.count === 1 ? "This account is in the latest Infloww import" : `These ${data.count} accounts are in the latest Infloww import`}{" "}but not linked to anyone, so {data.count === 1 ? "its" : "their"} links read $0. Link {data.count === 1 ? "it" : "them"} in Reporting, Creator setup.
        </p>
        <ul className="now-list">
          {data.accounts.map((account) => (
            <li key={account}>{account}</li>
          ))}
        </ul>
        <RLink to="/reporting" className="secondary-button tiny">Open Reporting</RLink>
      </div>
    </section>
  );
}
